/* eslint-disable */
import React, { useCallback, useEffect, useRef } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import AddExamOrthac from './pages/AddExamOrthac/AddExamOrthac';
import EmailConfirmation from './pages/EmailConfirmation/EmailConfirmation';
// import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import NotFound from './pages/NotFound/NotFound';
import NotFoundExam from './pages/NotFoundExam/NotFoundExam';
import NotFoundAdmin from './pages/NotFoundAdmin/NotFoundAdmin';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Register from './pages/Register/Register';
import ExamsArchive from './pages/ExamsArchive/ExamsArchive';
import RequestPassword from './pages/RequestPassword/RequestPassword';
import SingleTomographyReport from './pages/SingleTomographyReport/SingleTomographyReport';
import SingleRadiographyReport from './pages/SingleRadiographyReport/SingleRadiographyReport';
import TermsOfService from './pages/TermsOfService/TermsOfService';
import ControlPanel from './pages/ControlPanel/ControlPanel';
import Support from './pages/Support/Support';
import InstitutionsArchive from './pages/InstitutionsArchive/InstitutionsArchive';
import AddInstitution from './pages/AddInstitution/AddInstitution';
import Performance from './pages/Performance/Performance';
import EditTool from './pages/EditTool/EditTool';
import EditToolTeste from './pages/EditToolTeste/EditToolTeste';
import NoInstitution from './pages/NoInstitution/NoInstitution';
import UserProfile from './pages/UserProfile/UserProfile';
import Version from './pages/Version/Version';

import authenticationCheck from './libs/authenticationCheck';

import Api from './libs/Api'
import './App.css';
import NiftiEditorTool from './pages/NiftiEditorTool/NiftiEditorTool';
import NiftiAnnotationTool from './pages/NiftiAnnotationTool/NiftiAnnotationTool';
import WebVisualizer from './pages/WebVisualizer/WebVisualizer';
import WebVisualizerCNN from './pages/WebVisualizerCNN/WebVisualizerCNN';
import WebVisualizerDensitometry from './pages/WebVisualizerDensitometry/WebVisualizerDensitometry';

import { setExamsAdded, setUploadExams } from './//store/actions/exams';
import { clearSettings } from './store/actions/settings';
import { unregisterMeUser } from './store/actions/meUser';


const App = () => {
  
  const intervalRef = useRef();
  const dispatch = useDispatch();

  const refreshToken = useCallback(async () => {
    try {
      const response = await Api.refreshOrthancToken();

      // Verifica se a resposta foi bem-sucedida (status 200)
      if (response.status !== 200) {
        // Se a resposta não for 200, redireciona para o login
        console.error('Erro ao renovar o token:', response.status, response.data);
        localStorage.clear('hcatkn');
        localStorage.clear('hcrtkn');
        Cookies.remove('orthanc_token');
        Cookies.remove('refresh_token');
    
        dispatch(unregisterMeUser());
        dispatch(clearSettings());
        dispatch(setExamsAdded([]));
        dispatch(setUploadExams([]));
        window.location.href = '/login';
      }
    } catch (error) {
      console.error('Erro ao renovar o token:', error);
      localStorage.clear('hcatkn');
      localStorage.clear('hcrtkn');
  
      dispatch(unregisterMeUser());
      dispatch(clearSettings());
      dispatch(setExamsAdded([]));
      dispatch(setUploadExams([]));
      window.location.href = '/login';
    }
  }, []);


  useEffect(() => {
    // Lista de rotas onde o refreshToken não deve ser executado
    const excludedRoutes = [
      '/entrar',
      '/cadastrar',
      '/recuperar-senha',
      '/politica-de-privacidade',
      '/termos-de-uso',
    ];

    // Verifica se a rota atual está na lista de rotas excluídas
    const shouldRefreshToken = !excludedRoutes.includes(window.location.pathname) &&
      !window.location.pathname.startsWith('/confirmar-email');;

    if (shouldRefreshToken) {
      // Executa o refresh imediatamente e depois a cada 3 minutos (180000 ms)
      refreshToken();

      const interval = setInterval(() => refreshToken(), 18000);
      intervalRef.current = interval;

      // Limpa o intervalo quando o componente é desmontado ou a rota muda
      return () => clearInterval(interval);
    }
  }, [refreshToken]);

  return (
    <>
      <Router>
        {!authenticationCheck() &&
        !window.location.pathname.includes('/cadastrar') &&
        !window.location.pathname.includes('/recuperar-senha') &&
        !window.location.pathname.includes('/politica-de-privacidade') &&
        !window.location.pathname.includes('/termos-de-uso') &&
        !window.location.pathname.includes('/confirmar-email') ? (
          <Redirect to="/entrar" />
        ) : null}
        {authenticationCheck() &&
        (window.location.pathname.includes('/entrar') ||
          window.location.pathname.includes('/cadastrar') ||
          window.location.pathname.includes('/recuperar-senha') ||
          window.location.pathname.includes('/confirmar-email')) ? (
          <Redirect to="/" />
        ) : null}
        <Switch>
          <Route
            path="/entrar"
            render={() =>
              authenticationCheck() ? <Redirect to="/" /> : <Login />
            }
          />
          <Route exact path="/performance" component={Performance} />
          <Route exact path="/no-institution" component={NoInstitution} />
          <Route exact path="/version" component={Version} />
          <Route exact path="/cadastrar" component={Register} />
          <Route exact path="/recuperar-senha" component={RequestPassword} />
          <Route
            exact
            path="/confirmar-email/:token"
            component={EmailConfirmation}
          />
          <Route
            exact
            path="/"
            render={() =>
              authenticationCheck() ? (
                <ExamsArchive />
              ) : (
                <Redirect to="/entrar" />
              )
            }
          />
          <Route exact path="/relatorios" component={ExamsArchive} />
          <Route exact path="/relatorios/tomografias/:id" component={SingleTomographyReport} />
          <Route exact path="/relatorios/radiografias/:id" component={SingleRadiographyReport} />
          <Route path="/visualizador-web/:id" component={WebVisualizer} />
          <Route path="/relatorio-cnn/:id" component={WebVisualizerCNN} />
          <Route path="/relatorio-densitometria/:id" component={WebVisualizerDensitometry} />
          <Route
            path="/editar/:id"
            component={NiftiEditorTool}
          />
          <Route
            path="/anotar/:id"
            component={NiftiAnnotationTool}
          />
          <Route
            path="/editar2/:id"
            component={EditTool}
          />
          <Route path="/editar-teste" component={EditToolTeste} />
          <Route path="/adicionar-exame" component={AddExamOrthac} />
          <Route path="/painel-de-controle" component={ControlPanel} />
          <Route path="/ajuda" component={Support} />
          <Route path="/404-exame" component={NotFoundExam} />
          <Route path="/404-admin" component={NotFoundAdmin} />
          <Route path="/instituicoes" component={InstitutionsArchive} />
          <Route path="/cadastro-instituicao" component={AddInstitution} />
          <Route path="/meu-perfil" component={UserProfile} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </>
  );
};

export default App;
